export const space = '20px'
